export default __webpack_public_path__ + "static/FancyMediaContentSix-900c7f32bbba6ef78bfa1d420325c30e.webp";